import React, { useEffect } from 'react';
import "./ArticlePage.scss";
import { Layout, AdImage, ArticleFolo, ArticleList, Separator, Social, AdBlock } from '../../components';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

const ArticlePage = ({ location, match }) => {

    let title = "";
    let description = "";
    let img = "";
    let date = "";

    if (location?.state?.data) {
        title = location.state.data.title;
        description = location.state.data.description;
        img = location.state.data.img;
        date = location.state.data.date;
    }

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">
            <div className="article-page">
                <div className="article-page__container">
                    <div className="article-page__article">
                        <h2>{title}</h2>
                        <p className="article-page__description">{description}</p>
                        <div className="article-page__image-container">
                            <img src={img} alt={title} />
                        </div>
                        <p className="article-page__description-short">Lorem ipsum dolor sit amet consectetur adipisicing elit</p>
                        <span className="article-page__date">
                            {date}
                        </span>
                        <p className="article-page__paragraph-one">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita dignissimos officiis, modi soluta. Maiores officiis voluptate tempora dolorem atque ducimus temporibus quam distinctio, iure incidunt.
                        </p>

                        <h3>Gano la primera vuelta en 9s</h3>
                        <p className="article-page__paragraph">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita dignissimos officiis.
                        </p>

                        <img src="https://images.pexels.com/photos/848618/pexels-photo-848618.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt="noticia" />
                        <p className="article-page__paragraph">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita.
                        </p>

                        <h3>Gano la primera vuelta en 9s</h3>
                        <p className="article-page__paragraph">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita dignissimos officiis, modi soluta. Maiores officiis voluptate.
                        </p>
                        <p className="article-page__paragraph">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita.
                        </p>

                        <h3>Gano la primera vuelta en 9s</h3>
                        <p className="article-page__paragraph">
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Soluta excepturi accusantium rem. Voluptas voluptatem amet eum culpa nulla quam dignissimos inventore ipsam, iure harum aliquid esse tempore! Et eligendi unde expedita dignissimos officiis, modi soluta. Maiores officiis voluptate.
                        </p>
                    </div>
                    <div className="article-page__ad">
                        <AdImage
                            width="300px"
                            height="250px"
                        />
                        <AdImage
                            width="300px"
                            height="250px"
                        />
                    </div>
                </div>

                <h5>Articulos relacionados</h5>


                <div className="article-page__related">
                    <div className="article-page__related--articles">
                        <div className="article-page__related--main">
                            <ArticleFolo
                                title="3 tips de carpinteria"
                                tag="carpinteria"
                                img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                                author="El folo"
                                description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                                height="200px"
                                width="250px"
                                fontSize="1.3rem"
                            />
                            <ArticleFolo
                                title="3 tips de carpinteria"
                                tag="carpinteria"
                                img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                                author="El folo"
                                description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                                height="200px"
                                width="250px"
                                fontSize="1.3rem"
                            /><ArticleFolo
                                title="3 tips de carpinteria"
                                tag="carpinteria"
                                img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                                author="El folo"
                                description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                                height="200px"
                                width="250px"
                                fontSize="1.3rem"
                            />
                        </div>
                        <div className="article-page__related--ad">
                            <AdImage
                                width="300px"
                                height="250px"
                            />
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    )
}

export default ArticlePage;
